<template>
<div @click="selected" class="entry"
  v-bind:class="{rejected: entry.meta && entry.meta.rejected.length > 0}">

  <span class="entry-date">
    {{ timeAgo(entry.created_at) }}
  </span>
  <span class="entry-name">
    <span v-if="entry.data.name">{{entry.data.name}}</span>
  </span>
  <span class="entry-icons">
    <shield-icon v-if="entry.meta && entry.meta.rejected.length > 0"/>
    <shield-off-icon v-if="entry.meta && entry.meta.rejectOverride"/>
    <file-icon v-if="entry.files"></file-icon>
  </span>
  <span v-if="entry.data.message || entry.data.comments" class="entry-message">
    {{ entry.data.message || entry.data.comments }}
  </span>

</div>
</template>

<script>
// import 'buefy/lib/buefy.css';
import {
  FileIcon, ShieldIcon, ShieldOffIcon,
} from 'vue-feather-icons';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

export default {
  props: ['entry', 'form'],
  data() {
    return {
      modal: false,
    };
  },
  methods: {
    timeAgo(string) {
      if (new Date(string) > new Date(new Date().getFullYear(), new Date().getMonth(), 1)) {
        return dayjs(string).fromNow();
      }
      if (new Date(string).getFullYear() < new Date().getFullYear()) return dayjs(string).format('MM/D/YY');
      return dayjs(string).format('MMMM D');
    },
    selected(e) {
      this.$emit('viewEntry', e, this.entry);
    },
  },
  created() {
    dayjs.extend(relativeTime);
  },
  components: {
    FileIcon,
    ShieldIcon,
    ShieldOffIcon,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .entry {
    display: flex;
    background: white;
    padding: 15px 30px;
    border-bottom: 1px solid gray;
    transition: background 0.2s ease-in-out;
    justify-content: space-between;
  }

  .entry.rejected { opacity: 0.65; }
  .entry.rejected.selected { opacity: initial; }

  .entry span { font-size: 95%; }

  .entry span .feather { vertical-align: middle; }

  .entry .entry-name { min-width: 180px; }
  .entry .entry-date {
    min-width: 160px;
    color: hsl(0, 0%, 20%);
    font-style: oblique;
    font-weight: bold;
  }

  .entry-icons { display: flex; min-width: 60px; }

  .entry-message {
    width: 95%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .entry:hover, .entry.selected {
    cursor: pointer;
    background: var(--black);
    color:white;
  }

  .entry:hover .entry-date, .entry.selected .entry-date {
    color: hsl(0, 0%, 80%);
  }

</style>
